function invokeDesktop(command,args){
  const invoke=typeof window!=='undefined'?window.__TAURI__?.core?.invoke:null;
  if(!invoke)return Promise.resolve(false);
  return invoke(command,args).then(()=>true);
}

export function isNativeDesktopApp(){
  return Boolean(typeof window!=='undefined'&&window.__TAURI__?.core?.invoke);
}

export async function returnToDesktopLogin(){
  return invokeDesktop('return_to_login_window');
}

export async function exitDesktopApplication(){
  return invokeDesktop('exit_application');
}
